import { defineComponent as _defineComponent } from 'vue';
import { faArchive, faBan, faChartLine, faCircleNotch, faCloud, faKey, faPlug, faRecycle, faShieldAlt, faTachometerAlt, faUserLock, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { MESSAGES } from "@/components/ObjectStore/badgeMessages";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreBadge',
    props: {
        badge: null,
        size: { default: "lg" }
    },
    setup(__props) {
        const props = __props;
        const advantage = "storage-advantage";
        const disadvantage = "storage-disadvantage";
        const neutral = "storage-neutral";
        const transparent = "reduced-opacity";
        const stockMessage = computed(() => {
            return MESSAGES[props.badge.type];
        });
        const layerClasses = computed(() => {
            return [`fa-${props.size}`, "fa-fw"];
        });
        const badgeType = computed(() => {
            return props.badge.type;
        });
        const shrink = computed(() => {
            return { transform: "shrink-6" };
        });
        const message = computed(() => {
            return props.badge.message || "";
        });
        const title = computed(() => {
            return stockMessage.value + (message.value ? "\n\n" + markup(message.value ?? "", true) : "");
        });
        return { __sfc: true, props, advantage, disadvantage, neutral, transparent, stockMessage, layerClasses, badgeType, shrink, message, title, faArchive, faBan, faChartLine, faCircleNotch, faCloud, faKey, faPlug, faRecycle, faShieldAlt, faTachometerAlt, faUserLock, FontAwesomeIcon, FontAwesomeLayers };
    }
});
